export default __webpack_public_path__ + "16a0254df9c089340d05ae2096e13c72.png";